import * as React from 'react';
import { Paragraph1 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';

interface IPriceDiffProps {
  diff?: React.ReactElement;
}

export const PriceDiff: React.FC<IPriceDiffProps> = props => {
  return (
    <div className={styles['price-diff']}>
      <Paragraph1 fontWeight="700">{props.children}</Paragraph1>
      {props.diff}
    </div>
  );
};

PriceDiff.displayName = 'PriceDiff';
